import React from 'react'
import './teacher-assessment-form.css'
import { useParams } from "react-router-dom";
import StarRatings from './StarRatings';
import axios from 'axios';
import { baseUrl } from '../assets/Animations';
import { MdCheck } from 'react-icons/md';
import { convertSchoolAbbreviationsToNames } from '../utilityFunctions';


const TeacherAssessmentForm = () => {
    let {familyId, teacherId} = useParams()

    const [teacherInfo, setTeacherInfo] = React.useState({})
    const [selectedRating, setSelectedRating] = React.useState(0)
    const [hightLightsText, setHighlightsText] = React.useState('')
    const [favoriteThingText, setFavoriteThingText] = React.useState('')
    const [schoolAbb, setSchoolAbb] = React.useState('')
    const [schoolName, setSchoolName] = React.useState('')
    const [thankYouPopup, setThankYouPopup] = React.useState(false)
    const [familyName, setFamilyName] = React.useState('')
    const [submitting, setSubmitting] = React.useState(false)
    const [logoImage, setLogoImage] = React.useState('')
    
    React.useEffect(() => {
        getTeacherInfo()
        setTheSchool()
        getFamilyName()
    }, [])

    React.useEffect(() => {
        if(schoolAbb !== '') {
            if(schoolAbb === 'mma') {
                setLogoImage('https://www.mountainsidemusicacademy.com/logo.png')
            } else if(schoolAbb === 'lsma') {
                setLogoImage('https://www.lakesidemusicacademy.com/logo.png')
            } else if (schoolAbb === 'tma') {
                setLogoImage('https://www.treesidemusicacademy.com/logo.png')
            } else if (schoolAbb === 'mor') {
                setLogoImage('https://www.morningsidemusicacademy.com/logo.png')
            } else if (schoolAbb === 'psma') {
                setLogoImage('https://www.parksidemusicacademy.com/logo.png')
            }
        }
    })

    const getFamilyName = () => {
        axios.get(`${baseUrl}/school-management-name/${familyId}`)
        .then(res => {
            setFamilyName(res.data.familyName)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const getTeacherInfo = () => {
        axios.get(`${baseUrl}/teacher-image/${teacherId}`)
        .then(res => {
            setTeacherInfo(res.data)
            setTheSchool(res.data.School)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const setTheSchool = (school) => {
        setSchoolAbb(school)
        let fullName = convertSchoolAbbreviationsToNames(school)
        setSchoolName(fullName)
    };

    const submitFeedback = () => {
        setSubmitting(true)
        axios.post(`${baseUrl}/create-teacher-assessment`, {
            teacherId: teacherId,
            teacherName: teacherInfo.Name,
            familyName: familyName,
            school: schoolAbb,
            date: new Date(),
            familyId: familyId,
            starRating: selectedRating,
            teacherHighlights: hightLightsText,
            teacherFavorites: favoriteThingText,
          }
        )
        .then(res => {
            setSubmitting(false)
            setThankYouPopup(true)
        })
        .catch(err => {
            setSubmitting(false)
            setThankYouPopup(true)
            console.log(err)
        })
    }
    return (
        <div className="teacher-assessment-form__wrapper">
            {submitting ? <div className='teacher-assessment-form__submitting'>Submitting Feedback...</div>
            :
            <div>
            <div>
                <img className='teacher-assessment-form__logo' alt='school-logo' src={logoImage} />
            </div>
            {thankYouPopup ? 
                <div className="teacher-assessment-form__modal__thank-you">
                    <div className='teacher-assessment-thank-you__check'><MdCheck size={24} color='rgb(12, 148, 136)' /></div>
                    <div className='teacher-assessment__title'>Thank you for sharing!</div>
                    <div className='teacher-assessment__sub-title'>Your teacher really appreciate hearing about their impact on their students’ progress. This helps them to reflect on what they are doing well!</div>
                    <div>Your feedback has been successfully shared, you can now close this window. </div>
                </div>
            :
            <div className="teacher-assessment-form__modal">
                <div className='teacher-assessment-form__internal-modal'>
                    <div className='teacher-assessment-form__teacher-image__wrapper'>
                    <img className='teacher-assessment-form__logo__instead-of-teacher' alt='school-logo' src={logoImage}/>
                        <img className='teacher-assessment__teacher-image' src={`https://app.atharo.app/images/${teacherInfo.ImageName}`} alt='teacher-profile' />
                    </div>
                    <div className='teacher-assessment__title'>Leave teacher feedback for {teacherInfo.Name ? teacherInfo.Name : 'your teacher'}</div>
                    <div className='teacher-assessment-form__input-label'>How would you rate your experience with your instructor this semester?</div>
                    <div>
                        <StarRatings selectedRating={selectedRating} setSelectedRating={setSelectedRating} />
                    </div>
                    <div className='teacher-assessment-form__input-label'>Would you like to share any highlights or achievements?</div>
                    <textarea className='teacher-assessment-form__textarea' value={hightLightsText} placeholder='Type your message here...' onChange={(e) => setHighlightsText(e.target.value)} />
                    <div className='teacher-assessment-form__input-label'>What's your favorite thing about your instructor?</div>
                    <textarea className='teacher-assessment-form__textarea' value={favoriteThingText} placeholder='Type your message here...' onChange={(e) => setFavoriteThingText(e.target.value)} />
                    <div className='teacher-assessment-form__button-wrapper'>
                        <div className='teacher-assessment-form__button' onClick={() => submitFeedback()}>Submit Feedback</div>
                    </div>
                </div>
            </div>
            }
            </div>
            }
        </div>
    )
}
export default TeacherAssessmentForm;